import { Component, input } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-meeting-share',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './meeting-share.component.html',
  styleUrl: './meeting-share.component.scss'
})
export class MeetingShareComponent {

  meetingId = input<string>();

  // Share link information
  shareLink: string = '';
  // embedCode: string = '<table style="border-collapse:collapse;width:364px;border:1px solid #e5e5e5;border-radius:4px" data-type="scheduler-snippet">...</table>';
  iframeCode: string = '';

  constructor(private snackBar: MatSnackBar) {}

  ngOnInit(){
    this.shareLink = `${environment.uiUrl}/meeting-schedule/${this.meetingId()}`
    this.iframeCode = `<iframe src=${environment.uiUrl}/meeting-schedule/${this.meetingId()}
    style="width:100%;height:800px;border:none;border-radius:14px;box-shadow:0 4px 24px rgba(0,0,0,0.08);"
      allowfullscreen
      loading="lazy">
    </iframe>`
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
      .then(() => {
        // Show a success message using MatSnackBar
        this.snackBar.open('Copied to clipboard', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['copy-success-snackbar']
        });
      })
      .catch(err => {
        // Show an error message
        this.snackBar.open('Failed to copy text', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['copy-error-snackbar']
        });
        console.error('Error copying text: ', err);
      });
  }
}
